/**
 * Arquivo de Configuração de Imagens - White Label
 * 
 * Este arquivo centraliza todos os caminhos de imagens usadas no projeto.
 * Para personalizar para um novo cliente, basta alterar os caminhos aqui.
 */

const images = {
  // ============ LOGOS ============
  logos: {
    main: require('../imagens/Logos/onitelecom.png'),
    header: require('../imagens/Logos/Oniheader.png'),
    footer: require('../imagens/Logos/onitelecom.png'),
    mobile: require('../imagens/Logos/onitelecom.png'),
    favicon: '/Oni.png',
  },

  // ============ BANNERS / CARROSSEL ============
  banners: {
    desktop: [
      'https://i.postimg.cc/R0RRmDtv/slide1.jpg',
      'https://i.postimg.cc/LsNzwZdX/slide2.jpg',
      'https://i.postimg.cc/3NDmkSk4/slide3.jpg',
    ],
    mobile: [
      'https://i.postimg.cc/05JVMcR0/Banner-Mob-1.jpg',
      'https://i.postimg.cc/nhn2Wxs3/Banner-Mob-2.jpg',
      'https://i.postimg.cc/qvQwVFy4/Banner-Mob-3.jpg',
    ],
  },

  // ============ SERVIÇOS ESSENCIAIS ============
  servicosEssenciais: {
    consultaFatura: require('../imagens/Servicos_Essenciais/img1.png'),
    duvidas: require('../imagens/Servicos_Essenciais/img2.png'),
    faleConosco: require('../imagens/Servicos_Essenciais/img3.png'),
    recarga: require('../imagens/Servicos_Essenciais/img4.png'),
  },

  // ============ OFERTAS ============
  ofertas: {
    carimboGratis: require('../imagens/Ofertas/carimbo gratis.png'),
    
    // Apps de Entretenimento
    apps: {
      onigo: require('../imagens/Ofertas/onigo.png'),
      skyPlus: require('../imagens/Ofertas/sky+.png'),
      max: require('../imagens/Ofertas/max.png'),
      playkids: require('../imagens/Ofertas/playkids.png'),
      deezer: require('../imagens/Ofertas/deezer.png'),
    },
    
    // Apps de Escolha (50x50)
    appsEscolha: {
      estudaMais: require('../imagens/Ofertas/50x50/estuda+.png'),
      hub: require('../imagens/Ofertas/50x50/hub.png'),
      kaspersky: require('../imagens/Ofertas/50x50/karspersky.png'),
      leitura360: require('../imagens/Ofertas/50x50/leitura360.png'),
    },
  },

  // ============ SERVIÇOS ESSENCIAIS INTERNET ============
  servicosInternet: {
    // Adicionar conforme necessário
  },

  // ============ INFINITE POSSIBILITIES ============
  infinitePossibilities: {
    logos: [
      require('../imagens/Infinite_Possibilities/img1.png'),
      require('../imagens/Infinite_Possibilities/img2.png'),
      require('../imagens/Infinite_Possibilities/img3.png'),
      require('../imagens/Infinite_Possibilities/img4.png'),
      require('../imagens/Infinite_Possibilities/img5.png'),
      require('../imagens/Infinite_Possibilities/img6.png'),
      require('../imagens/Infinite_Possibilities/img7.png'),
      require('../imagens/Infinite_Possibilities/img8.png'),
      require('../imagens/Infinite_Possibilities/img9.png'),
      require('../imagens/Infinite_Possibilities/img10.png'),
      require('../imagens/Infinite_Possibilities/img11.png'),
      require('../imagens/Infinite_Possibilities/img12.png'),
    ],
    alt: ['5G', 'Globoplay', 'Deezer', 'Max', 'Premiere', 'Sky+', 'On', 'Telecine', 'On Vida', 'PlayKids', 'Combate', 'Looke'],
  },

  // ============ APP EXCLUSIVO ============
  appExclusivo: {
    logo: require('../imagens/App_Exclusivo/Onigo.png'),
    telas: require('../imagens/App_Exclusivo/Onigo_Telas.png'),
    controles: {
      play: require('../imagens/App_Exclusivo/img1.png'),
      pause: require('../imagens/App_Exclusivo/img2.png'),
      retroceder: require('../imagens/App_Exclusivo/img3.png'),
      avancar: require('../imagens/App_Exclusivo/img4.png'),
    },
  },

  // ============ PLANO CONTROLE ============
  planoControle: {
    smartphone: require('../imagens/Plano_Controle/img2.png'),
    chip: require('../imagens/Plano_Controle/img1.png'),
    background5g: require('../imagens/Plano_Controle/5g.jpg'),
    figurafeminina: require('../imagens/Plano_Controle/figurafeminina.png'),
  },

  // ============ TELEFONIA BANNER ============
  telefoniaBanner: {
    // Adicionar conforme necessário
  },

  // ============ HELP SECTION ============
  helpSection: {
    perguntasFrequentes: require('../imagens/Help_Section/img1.png'),
    atendimento: require('../imagens/Help_Section/img2.png'),
    planos: require('../imagens/Help_Section/img3.png'),
  },

  // ============ QUEM SOMOS ============
  quemSomos: {
    img: require('../imagens/Quem_somos/img.png'),
  },

  // ============ ENTRETENIMENTO ============
  entretenimento: {
    deezer: {
      logo: require('../imagens/Entretenimento/Logo DEEZER.png'),
      banner: require('../imagens/Entretenimento/DEEZER.jpg'),
    },
  },

  // ============ OFERTAS CHIPS ============
  ofertasChips: {
    img1: require('../imagens/Ofertas_chips/img1.png'),
    img2: require('../imagens/Ofertas_chips/img2.png'),
    img3: require('../imagens/Ofertas_chips/img3.png'),
    img4: require('../imagens/Ofertas_chips/img4.png'),
  },

  // ============ SERVIÇOS ESSENCIAIS ============
  servicosEssenciais: {
    img1: require('../imagens/Servicos_Essenciais/img1.png'),
    img2: require('../imagens/Servicos_Essenciais/img2.png'),
    img3: require('../imagens/Servicos_Essenciais/img3.png'),
    img4: require('../imagens/Servicos_Essenciais/img4.png'),
  },

  // ============ SERVIÇOS ESSENCIAIS INTERNET ============
  servicosEssenciaisInternet: {
    img1: require('../imagens/Servicos_Essenciais_Internet/img1.png'),
    img2: require('../imagens/Servicos_Essenciais_Internet/img2.png'),
    img3: require('../imagens/Servicos_Essenciais_Internet/img3.png'),
    img4: require('../imagens/Servicos_Essenciais_Internet/img4.png'),
  },

  // ============ TELEFONIA BANNER ============
  telefoniaBanner: {
    img1: require('../imagens/Telefonia_Banner/img1.png'),
  },

  // ============ APP STORES ============
  appStores: {
    googlePlay: require('../imagens/Logos/onitelecom.png'), // Substituir pela imagem correta
    appStore: require('../imagens/Logos/onitelecom.png'),   // Substituir pela imagem correta
  },

  // ============ ÍCONES E ASSETS ============
  icons: {
    // Adicionar ícones customizados se houver
  },

  // ============ PLACEHOLDERS ============
  placeholders: {
    user: '/assets/placeholder-user.png',
    image: '/assets/placeholder-image.png',
    logo: '/assets/placeholder-logo.png',
  },
};

/**
 * Função auxiliar para obter uma imagem
 * Uso: getImage('logos.main')
 */
export const getImage = (path) => {
  const keys = path.split('.');
  let value = images;
  
  for (const key of keys) {
    value = value[key];
    if (value === undefined) {
      console.warn(`Imagem não encontrada: ${path}`);
      return '/assets/placeholder-image.png';
    }
  }
  
  return value;
};

/**
 * Função para obter URL de imagem externa
 * Se a imagem estiver hospedada externamente, retorna a URL
 * Caso contrário, retorna o caminho local
 */
export const getImageUrl = (path, isExternal = false) => {
  if (isExternal && typeof path === 'string' && path.startsWith('http')) {
    return path;
  }
  
  return getImage(path);
};

/**
 * Função para criar srcset para imagens responsivas
 */
export const createSrcSet = (imagePath, sizes = [1, 2, 3]) => {
  const basePath = imagePath.replace(/\.[^/.]+$/, ''); // Remove extensão
  const ext = imagePath.split('.').pop();
  
  return sizes.map(size => `${basePath}@${size}x.${ext} ${size}x`).join(', ');
};

export default images;
